import { render, staticRenderFns } from "./appproduct.vue?vue&type=template&id=7a08f8f8"
import script from "./appproduct.vue?vue&type=script&lang=js"
export * from "./appproduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports